<template>
  <div class="email-form">
    <h5 class="text-center">{{ this.$i18n.t("gateway/view:login:instructions") }}</h5>
    <br>

    <form @submit.prevent="submitEmail()">
      <fieldset class="form-group justify-content-center field-loginform-username required px-3">
        <label class="label label-default control-label">{{$t('gateway/view:login:email')}}</label>
        <input
          class="form-control form-control-lg col-sm-12"
          type="text"
          autocomplete="off"
          autofocus="true"
          v-model="email"
          :placeholder="$t('gateway/view:login:email:placeholder')"
        />
      </fieldset>
    </form>

    <div class="form-group">
        <div class="col-sm-12 text-center mt-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="rememberMe" value="" id="flexCheckDefault">
            <label class="form-check-label pl-2" for="flexCheckDefault">
              {{$t('gateway/view:login:remember_me')}}
            </label>
          </div>
          <br/>
          <button v-on:click="submitEmail()" class="btn btn-sm  btn-primary btn-fixed">
            {{$t('gateway/view:login:next_button')}}
          </button>
        </div>
    </div>
  </div>
</template>

<script>
import { EMAIL_SUBMIT, CHECK_IF_SESSION_EXISTS, SET_GATEWAY_LOADING, SET_ONBOARDING, UPDATE_PRODUCT_DEEP_LINK, SET_SHOW_SIDE_BAR} from "@/store/actions.type";
import {
SET_JWT_INTERVAL
} from '../store/mutations.type';
import { mapState, mapGetters } from "vuex";
export default {
  name: "emailForm",
  data() {
    return {
      email: null,
      rememberMe: 0,
    };
  },
  methods: {
    submitEmail() {
      var data = {'email':this.email, 'rememberMe':this.rememberMe};
      this.$store
        .dispatch(SET_GATEWAY_LOADING,  true )
        .then(()=>{
          this.$store
            .dispatch(EMAIL_SUBMIT,  data )
            .then(
              data =>{
                if(data.code === 200){
                  if(data.loginPhase === "password"){
                    this.$router.push({ name: "login-password" });
                  }
                  else if(data.loginPhase === "registration"){
                    this.$router.push({ name: "registration-verification-code" });
                  }
                  else if(data.loginPhase === "changePassword"){
                    this.$router.push({ name: "login-change-password" });
                  }
                  else{
                    this.$store.dispatch(SET_SHOW_SIDE_BAR, true);
                    if(data.redirect){
                      window.location.href = data.redirect;
                    }
                    else if(data.redirectInternal){
                      this.$router.push({ name: data.redirectInternal });
                    }
                  }
                }
              }
            )
            .catch(()=>{
              this.$store.dispatch(SET_GATEWAY_LOADING, false);
            });
        });
    },
    clearJwtInterval(){
      if(this.jwtInterval){
        this.$store.commit(SET_JWT_INTERVAL, null);
      }
    }
  },
  mounted(){

    document.body.classList.add('gateway');
    document.body.classList.remove('store');

    if(this.remembered){
      this.email = this.cachedEmail;
      this.rememberMe = this.remembered;
    }

    if((typeof this.$route.params === 'object') && (this.$route.params.product)){
      this.$store.dispatch(UPDATE_PRODUCT_DEEP_LINK, this.$route.params);
    }

    this.$store.dispatch(CHECK_IF_SESSION_EXISTS).then((data) => {
      if(data.redirect){
        window.location.href = data.redirect;
      }
      else if(data.redirectInternal){
        this.$router.push({ name: data.redirectInternal });
      }
      else{
        this.$store.dispatch(SET_ONBOARDING, false);
        this.$store.dispatch(SET_GATEWAY_LOADING, false);
      }
    }).catch(() => {
      this.$store.dispatch(SET_ONBOARDING, false);
      this.$store.dispatch(SET_GATEWAY_LOADING, false);
    });

    this.clearJwtInterval();

    this.$store.dispatch(SET_SHOW_SIDE_BAR, false);

  },
  computed: {
    ...mapState({
      cachedEmail: state => state.auth.user.username,
      remembered: state => state.auth.user.rememberMe,
    }),
    ...mapGetters(['jwtInterval']),
  }
};
</script>
